import { useEffect, useState } from "react";
import { apiList } from "../../helpers/apiList";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import InfoModal from "../../components/common/InfoModal";
import { useLocation } from "react-router-dom";
import PaymentStatusModal from "./components/PaymentStatusModal";
import { formatDateMonth } from "../../helpers/DateHelpers";
import PaymentReceipt from "./components/PaymentReceipt";

export default function WalletTopup() {
  const loggedInUserName = sessionStorage.getItem("username");
  const location = useLocation();

  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showInfo, setShowInfo] = useState(false);
  const [status, setStatus] = useState("success");
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get("orderId");

    if (orderId) {
      handleCheckStatus(orderId);
    }

  }, [location.search]);

  const handleCheckStatus = async (id) => {
    try {
      setLoading(true);
      const response = await axiosGetApi(`${apiList.VEGAAH_PAYMENT_GATEWAY_STATUS}/${id}`);
      const data = response?.data?.data;
      if (response?.data?.status === true && data) {
        setData(data);
        setStatus(data.status.toLowerCase());
        setShowStatusModal(true);
      }

    } catch (err) {
      setError("Unable to check payment status. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleTopup = async () => {
    const numericAmount = Number(amount);

    // 🔐 Validation
     if (!amount) {
       return setError("Amount is required");
     }
   
     if (isNaN(numericAmount)) {
       return setError("Invalid amount");
     }
   
     if (numericAmount < 1000) {
       return setError("Minimum amount allowed is ₹1,000");
     }
   
     if (numericAmount > 50000) {
       return setError("Maximum allowed is ₹50,000");
     }

     const payload = {
      username: loggedInUserName,
      amount: Number(numericAmount),
     }

    try {
      setLoading(true);
      setError("");

      const response = await axiosPostApi(apiList.CREATE_PAYMENT_GATEWAY, payload);

      const data = response?.data?.data;
      
      if ( response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
        // Same Tab
        window.location.href = data?.paymentUrl;

        // New Tab
        // window.open(data.paymentUrl, "_blank");

        // Optionally, you can navigate to a separate route that contains the iframe for the payment gateway
        // navigate("/payment-gateway", {
        //   state: {
        //     paymentUrl: data.paymentUrl,
        //     orderId: data.orderId
        //   }
        // });

        // alert("Payment window opened. Complete the payment and return here.");
        setShowInfo(true);
        setAmount("");
      }
    } catch (err) {
      setError("Unable to initiate payment. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
  let value = e.target.value;

  // Allow only numbers and one decimal point with max 2 digits after decimal
  const regex = /^\d*(\.\d{0,2})?$/;

  if (value === "" || regex.test(value)) {
    setAmount(value);
    if (error) setError("");
  }
};

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md space-y-6">
        
        <h1 className="text-2xl font-bold text-center text-gray-800">
          Add Money to Wallet
        </h1>

        {/* Amount Input */}
        <div className="pt-2">
          <label className="text-sm text-gray-600">
            Enter Amount (₹)
          </label>
          <input
            type="text"
            value={amount}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") {
                e.preventDefault();
              }
            }}
            maxLength={5}
            inputMode="decimal"
            placeholder="Enter amount"
            className="w-full border text-right placeholder:text-left rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Error */}
        {error && (
          <p className="text-red-500 text-sm text-start mt-1">
            {error}
          </p>
        )}

        {/* Quick Select Buttons */}
        <div className="flex gap-3">
          {[1000, 2000, 5000].map((amt) => (
            <button
              key={amt}
              onClick={() => setAmount(amt)}
              className="flex-1 bg-gray-100 hover:bg-gray-200 py-2 rounded-lg text-sm font-medium border transition duration-200"
            >
              ₹{amt}
            </button>
          ))}
        </div>

        {/* Pay Button */}
        <button
          onClick={handleTopup}
          disabled={loading || !amount}
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-xl font-semibold transition duration-200 disabled:opacity-50"
        >
          {loading ? "Processing..." : `Add ₹${amount || 0}`}
        </button>

        <p className="text-xs text-gray-400 text-center">
          Secure payment via UPI / Card
        </p>
      </div>

    {showInfo && 
      <InfoModal
        show={showInfo}
        handleClose={() => {
          setShowInfo(false); 
          window.history.replaceState({}, document.title, "/topUpWallet")}
        }
        infoMessage="Opening payment page..."
        // redirect="/dashboard"
      />
    }

    {/* {showStatusModal && 
      <PaymentStatusModal
        status={status}
        amount={data?.amount || 0}
        txnId={data?.transactionId || ""}
        orderId={data?.orderId || ""}
        date={formatDateMonth(data?.updatedDate)}
        paymentMethod={data?.paymentMethod || "N/A"}
        onClose={() => setShowStatusModal(false)}
      />
  } */}

      {showStatusModal && (
        <PaymentReceipt
          handleClose={() => setShowStatusModal(false)}
          data={data}
        />
      )}
    </div>
  );
}